import React, {useEffect, useState} from 'react'
import CPCRatingFullReportView from "../../../views/ver_24.10/ProgramRating/CPCStarsRating/CPCRatingFullReport.view";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {fetchRatingProgramService} from "../../../services/rating.service";
import Loader from "../../../ui_library/ver_24.10/Loader/Loader.comp";
import {APP_STATUS} from "../../../utils/constants";
import {RATING_STEPS} from "../../../utils/RatingFlowSteps";

const CPCRatingFullReport = () => {
    const history = useHistory();
    const location = useLocation();
    const { programId } = useParams();
    const [pdfUrl, setPdfUrl] = useState(null);
    const [appStatusV3, setAppStatusV3] = useState(null);
    const [appStatus, setAppStatus] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    const currentStatus = location.state?.currentStatus || 'FULL_REPORT';

    useEffect(() => {
        setShowLoader(true);

        const fetchReportData = async () => {
            try {
                await fetchProgramReport();
            } catch (error) {
                // Handle error if needed
                console.error('Error fetching program report:', error);
            } finally {
                setShowLoader(false);
            }
        };

        fetchReportData().then(r => console.log(r));
    }, [programId]);

    const fetchProgramReport = async () => {
        const result = await fetchRatingProgramService(programId);
        if (result.data && result.data.program_application) {
            setAppStatus(result.data.program_application.app_status);
            setAppStatusV3(result.data.program_application.app_status_v3);
            if (
                result.data.program_application.app_status_v3 < APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED
            ) {
                history.push(`/dq_stars_rating/${programId}`);
            } else {
                setPdfUrl(result.data.program_application.report_file_url);
            }
        }
    };

    const data = {
        pdfUrl,
        programId,
        appStatusV3,
        appStatus,
        currentStatus,
        RATING_STEPS
    };

    // Actions handling business logic
    const actions = {
        createAssessmentAction: () => {
            history.push(`/rating/${programId}/welcome_assessment`);
        },
        accessAssessmentAction: (programId, appStatus) => {
            if (appStatus === APP_STATUS.ASSESSMENTS_PUBLISHED) {
                history.push(`/rating/${programId}/access_assessment`);
            } else if (appStatus === APP_STATUS.ASSESSMENTS_READY) {
                history.push(`/rating/${programId}/select_assessment`);
            } else {
                history.push(`/rating/${programId}/welcome_assessment`);
            }
        },
    };

    // Configuration options for visual appearance
    const options = {
    };

    if (showLoader) {
        return <Loader />;
    }

    return (
        <>
            <CPCRatingFullReportView
                data={data}
                actions={actions}
                options={options}
            />
        </>
    );
}

export default CPCRatingFullReport;